import { Component } from '@angular/core';

@Component({
	selector: 'app-payment-skeleton-item',
	imports: [],
	templateUrl: './payment-skeleton-item.component.html',
	styleUrl: './payment-skeleton-item.component.scss',
})
export class PaymentSkeletonItemComponent {}
